var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.519531,
    y: 1.03845,
    width: 35,
    height: 35,
    stroke: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1593 10.9008L9.01953 18.4997L15.1593 26.0986C15.2147 26.1882 15.2852 26.2622 15.3658 26.3154C15.4465 26.3686 15.5355 26.3999 15.6269 26.407C15.7182 26.4142 15.8097 26.3971 15.8952 26.357C15.9808 26.3168 16.0583 26.2545 16.1225 26.1742C16.1868 26.094 16.2363 25.9977 16.2677 25.8918C16.2991 25.786 16.3116 25.673 16.3045 25.5607C16.2974 25.4483 16.2707 25.3392 16.2263 25.2406C16.182 25.1421 16.1209 25.0564 16.0473 24.9894L11.4537 19.2863L23.6756 19.2863C23.8451 19.2863 24.0076 19.2034 24.1274 19.0559C24.2472 18.9084 24.3145 18.7083 24.3145 18.4997C24.3145 18.291 24.2472 18.091 24.1274 17.9434C24.0076 17.7959 23.8451 17.713 23.6756 17.713L11.4537 17.713L16.0473 12.0099C16.1668 11.8618 16.2335 11.6613 16.2329 11.4526C16.2323 11.2438 16.1644 11.0439 16.0441 10.8968C15.9238 10.7497 15.761 10.6675 15.5914 10.6683C15.4219 10.669 15.2595 10.7526 15.1401 10.9008L15.1593 10.9008Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a171713e98bc19459e6d94793ceeb274.svg";
export { ForwardRef as ReactComponent };